/**
 * Mobile: move PDP buy controls next to #mobileheaderbottom so they share
 * the same position:fixed containing block (avoids iOS overlap / jitter).
 * Also hide the bar when the footer enters the viewport.
 *
 * @param {ParentNode} [root=document]
 */
const MOBILE_MQ = '(max-width: 991px)';

export function initPdpBuySticky(root = document) {
  const detail = root.querySelector('.catalog_detail');
  if (!detail) {
    return;
  }

  const buyControls =
    detail.querySelector('.counter_wrapp.pdp__buy-controls') ||
    document.querySelector('.counter_wrapp.pdp__buy-controls');
  const footer = document.getElementById('footer');
  const dock = document.getElementById('pdp-buy-dock');
  if (!buyControls || !footer) {
    return;
  }

  if (buyControls.dataset.pdpBuyStickyInited === '1') {
    return;
  }
  buyControls.dataset.pdpBuyStickyInited = '1';

  let slot = buyControls.previousElementSibling;
  if (!slot || !slot.classList.contains('pdp__buy-controls-slot')) {
    slot = document.createElement('div');
    slot.className = 'pdp__buy-controls-slot';
    buyControls.parentNode.insertBefore(slot, buyControls);
  }

  const tab = document.getElementById('mobileheaderbottom');
  const mq = window.matchMedia(MOBILE_MQ);

  const isTabVisible = () => {
    if (!tab) {
      return false;
    }
    const style = window.getComputedStyle(tab);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }
    return tab.getBoundingClientRect().height > 0;
  };

  const syncDockToTab = () => {
    if (!dock || dock.hidden) {
      return;
    }
    if (!isTabVisible()) {
      dock.style.bottom = '';
      return;
    }
    const tabBottom = Number.parseFloat(window.getComputedStyle(tab).bottom) || 0;
    const tabHeight = tab.getBoundingClientRect().height;
    dock.style.bottom = `${Math.round(tabBottom + tabHeight)}px`;
  };

  const place = () => {
    if (!dock) {
      return;
    }
    if (mq.matches) {
      dock.appendChild(buyControls);
      dock.hidden = false;
      syncDockToTab();
    } else if (slot.parentNode) {
      slot.parentNode.insertBefore(buyControls, slot.nextSibling);
      dock.hidden = true;
      dock.style.bottom = '';
    }
  };

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', place);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(place);
  }

  window.addEventListener('resize', syncDockToTab, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncDockToTab, { passive: true });
  }

  place();

  const sync = (nearFooter) => {
    (dock || buyControls).classList.toggle('is-near-footer', nearFooter);
  };

  if (typeof IntersectionObserver === 'undefined') {
    return;
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      sync(Boolean(entry && entry.isIntersecting));
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(footer);
}
